import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dev': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M120.1 208.3c3.9 2.9 5.8 7.3 5.8 13.1v69.7c0 5.8-1.9 10.2-5.8 13.1-3.9 2.9-7.8 4.4-11.6 4.4h-17.5v-104.5h17.4c3.9 0 7.8 1.4 11.7 4.3zM404.1 32c24.2 0 43.8 19.6 43.9 43.8v360.4c-0.1 24.2-19.7 43.8-43.9 43.8h-360.2c-24.2 0-43.8-19.6-43.9-43.8v-360.4c0.1-24.2 19.7-43.8 43.9-43.8h360.2zM154.2 291.2l0-70.9c0-18.8-11.9-47.3-47.4-47.3h-47.4v165.5h46.4c36.8 0.1 48.4-28.4 48.4-47.3zM254.9 202.5l0-29.5h-63.2c-11.2 0.3-20 9.5-19.7 20.7v125.1c0.3 11.2 9.6 20 20.7 19.7h62.2v-29.6h-53.3v-38.4h32.6v-29.6h-32.6v-38.4h53.3zM358.5 317.8l38.5-144.8h-32.6l-29.6 113.7-29.7-113.7h-32.6l38.5 144.8c10.6 24.6 34.2 30.8 47.4 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dev.js
// module id = 790
// module chunks = 0